<template>
    <div class="flex-ns">
        <div class="w-100 flex flex-wrap">
            <div class="form-group pr2-ns w-100 w-50-ns">
                <label class="control-label">{{ strings['shipping_name'] }}</label>
                <input class="form-control placeholder-no-fix" type="text" autocomplete="false" v-bind:placeholder="strings['shipping_name']" name="name" v-model="alternative.name" v-bind:class="{ errorcontrol: emptyName }" maxlength="34" />
                <div class="form-group w-100 washed-yellow bg-dark-red ph3 pv2" v-if="nameCheck == false">{{ strings['input_error_only_chars'] }}</div>
            </div>
            <div class="form-group pr2-ns w-100 w-50-ns">
                <label class="control-label">{{ strings['shipping_surname'] }}</label>
                <input class="form-control placeholder-no-fix" type="text" autocomplete="false" v-bind:placeholder="strings['shipping_surname']" name="surname" v-model="alternative.surname" v-bind:class="{ errorcontrol: emptySurname }" maxlength="34" />
                <div class="form-group w-100 washed-yellow bg-dark-red ph3 pv2" v-if="surnameCheck == false">{{ strings['input_error_only_chars'] }}</div>
            </div>
            <div class="form-group pr2-ns w-100">
                <label class="control-label">{{ strings['company_name'] || 'Nome Azienda' }}</label>
                <input class="form-control placeholder-no-fix" type="text" autocomplete="false" v-bind:placeholder="strings['company_name'] || 'Nome Azienda (opzionale)'" name="company_name" v-model="alternative.company_name" maxlength="34" />
                <div class="form-group w-100 washed-yellow bg-dark-red ph3 pv2" v-if="companyNameCheck == false">{{ strings['input_error_only_chars'] }}</div>
            </div>
            <div class="form-group pr2-ns w-100 w-50-ns">
                <label class="control-label">{{ strings['shipping_address'] }}</label>
                <input class="form-control placeholder-no-fix" type="text" v-bind:placeholder="strings['shipping_address']" name="location" v-model="alternative.address" maxlength="34" minlength="6" />
                <div class="form-group w-100 washed-yellow bg-dark-red ph3 pv2" v-if="addressCheck == false">{{ strings['only_latin_charsets'] }}</div>
                <div class="form-group w-100 washed-yellow bg-dark-red ph3 pv2" v-if="addressTooShort">{{ strings['adress_limit_char'] }}</div>
            </div>
            <div class="form-group pr2-ns w-100 w-50-ns">
                <label class="control-label">{{ strings['shipping_zip_code'] }}</label>
                <input class="form-control placeholder-no-fix" type="text" autocomplete="false" v-bind:placeholder="strings['shipping_zip_code']" name="zipcode" v-model="alternative.zip_code" maxlength="15" />
                <div class="form-group w-100 washed-yellow bg-dark-red ph3 pv2" v-if="zipCodeCheck == false">{{ strings['only_latin_charsets'] }}</div>
            </div>
            <div class="form-group pr2-ns w-100 w-50-ns">
                <label class="control-label">{{ strings['shipping_city'] }}</label>
                <input class="form-control placeholder-no-fix" type="text" autocomplete="false" v-bind:placeholder="strings['shipping_city']" name="city" v-model="alternative.city" maxlength="34" />
                <div class="form-group w-100 washed-yellow bg-dark-red ph3 pv2" v-if="cityCheck == false">{{ strings['input_error_only_chars'] }}</div>
            </div>
            <div class="form-group pr2-ns w-100 w-50-ns">
                <label class="control-label">{{ strings['shipping_district'] }}</label>
                <input class="form-control placeholder-no-fix" type="text" autocomplete="false" v-bind:placeholder="strings['shipping_district']" name="district" v-model="alternative.district" maxlength="34" />
                <div class="form-group w-100 washed-yellow bg-dark-red ph3 pv2" v-if="districtCheck == false">{{ strings['input_error_only_chars'] }}</div>
            </div>
            <div class="form-group pr2-ns w-100 w-50-ns">
                <label class="control-label">{{ strings['shipping_country'] }}</label>
                <select class="form-control" name="country_id" v-model="alternative.country" autocomplete="false">
                    <option selected disabled value="---">{{ strings['shipping_country'] }}</option>
                    <option v-for="option in countries" v-bind:value="option.iso_code" v-bind:key="option.id" :selected="option.iso_code == alternative.country">{{ option.name }}</option>
                </select>
            </div>
            <div class="form-group pr2-ns w-100 w-50-ns">
                <label class="control-label">{{ strings['shipping_telephone'] }}</label>
                <div class="flex">
                    <input class="form-control placeholder-no-fix" type="text" autocomplete="false" placeholder="+000" name="telephone_prefix" v-model="telephonePrefix" readonly style="width: 80px; margin-right: 8px; background-color: #f5f5f5; cursor: not-allowed;" />
                    <input class="form-control placeholder-no-fix flex-1" type="text" autocomplete="false" v-bind:placeholder="getTelephoneNumberPlaceholder()" name="telephone_number" v-model="telephoneNumber" />
                </div>
                <div class="form-group w-100 washed-yellow bg-dark-red ph3 pv2" v-if="telephoneCheck == false">{{ strings['input_error_only_numbers'] }}</div>
            </div>
            <div class="form-group w-100">
                <button class="w-40 confirmbutton" v-bind:disabled="checked === false" v-on:click="$emit('check')">{{ strings['confirm'] }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js'

export default {
    props: ['address', 'strings', 'country', 'countries'],
    data: function () {
        let data = {
            // zoom: 11,
            // center: { lat: 37.4221, lng: -122.0841 },
            // currentPlace: '',
            // markers: [],
            // place: null,
            alternative: this.address,
            checked: false,
            emptyName: false,
            emptySurname: false,
            emptyCompanyName: false,
            emptyAddress: false,
            emptyZipCode: false,
            emptyDistrict: false,
            emptyCity: false,
            emptyCountry: false,
            emptyTelephone: false,
            addressTooShort: false,
            telephonePrefix: '',
            telephoneNumber: '',
            // autocompleteOptions: {
            //     componentRestrictions: {
            //         country: [],
            //     }
            // },
            listCountry: this.countries,
            charsetsLatin: true,
            nameCheck: true,
            surnameCheck: true,
            companyNameCheck: true,
            addressCheck: true,
            zipCodeCheck: true,
            cityCheck: true,
            districtCheck: true,
            telephoneCheck: true,
            countryPrefixes: {
                'AD': '+376', 'AE': '+971', 'AF': '+93', 'AG': '+1', 'AI': '+1', 'AL': '+355', 'AM': '+374', 'AO': '+244',
                'AR': '+54', 'AS': '+1', 'AT': '+43', 'AU': '+61', 'AW': '+297', 'AX': '+358', 'AZ': '+994', 'BA': '+387',
                'BB': '+1', 'BD': '+880', 'BE': '+32', 'BF': '+226', 'BG': '+359', 'BH': '+973', 'BI': '+257', 'BJ': '+229',
                'BL': '+590', 'BM': '+1', 'BN': '+673', 'BO': '+591', 'BQ': '+599', 'BR': '+55', 'BS': '+1', 'BT': '+975',
                'BW': '+267', 'BY': '+375', 'BZ': '+501', 'CA': '+1', 'CC': '+61', 'CD': '+243', 'CF': '+236', 'CG': '+242',
                'CH': '+41', 'CI': '+225', 'CK': '+682', 'CL': '+56', 'CM': '+237', 'CN': '+86', 'CO': '+57', 'CR': '+506',
                'CU': '+53', 'CV': '+238', 'CW': '+599', 'CX': '+61', 'CY': '+357', 'CZ': '+420', 'DE': '+49', 'DJ': '+253',
                'DK': '+45', 'DM': '+1', 'DO': '+1', 'DZ': '+213', 'EC': '+593', 'EE': '+372', 'EG': '+20', 'EH': '+212',
                'ER': '+291', 'ES': '+34', 'ET': '+251', 'FI': '+358', 'FJ': '+679', 'FK': '+500', 'FM': '+691', 'FO': '+298',
                'FR': '+33', 'GA': '+241', 'GB': '+44', 'GD': '+1', 'GE': '+995', 'GF': '+594', 'GG': '+44', 'GH': '+233',
                'GI': '+350', 'GL': '+299', 'GM': '+220', 'GN': '+224', 'GP': '+590', 'GQ': '+240', 'GR': '+30', 'GT': '+502',
                'GU': '+1', 'GW': '+245', 'GY': '+592', 'HK': '+852', 'HN': '+504', 'HR': '+385', 'HT': '+509', 'HU': '+36',
                'ID': '+62', 'IE': '+353', 'IL': '+972', 'IM': '+44', 'IN': '+91', 'IO': '+246', 'IQ': '+964', 'IR': '+98',
                'IS': '+354', 'IT': '+39', 'JE': '+44', 'JM': '+1', 'JO': '+962', 'JP': '+81', 'KE': '+254', 'KG': '+996',
                'KH': '+855', 'KI': '+686', 'KM': '+269', 'KN': '+1', 'KP': '+850', 'KR': '+82', 'KW': '+965', 'KY': '+1',
                'KZ': '+7', 'LA': '+856', 'LB': '+961', 'LC': '+1', 'LI': '+423', 'LK': '+94', 'LR': '+231', 'LS': '+266',
                'LT': '+370', 'LU': '+352', 'LV': '+371', 'LY': '+218', 'MA': '+212', 'MC': '+377', 'MD': '+373', 'ME': '+382',
                'MF': '+590', 'MG': '+261', 'MH': '+692', 'MK': '+389', 'ML': '+223', 'MM': '+95', 'MN': '+976', 'MO': '+853',
                'MP': '+1', 'MQ': '+596', 'MR': '+222', 'MS': '+1', 'MT': '+356', 'MU': '+230', 'MV': '+960', 'MW': '+265',
                'MX': '+52', 'MY': '+60', 'MZ': '+258', 'NA': '+264', 'NC': '+687', 'NE': '+227', 'NF': '+672', 'NG': '+234',
                'NI': '+505', 'NL': '+31', 'NO': '+47', 'NP': '+977', 'NR': '+674', 'NU': '+683', 'NZ': '+64', 'OM': '+968',
                'PA': '+507', 'PE': '+51', 'PF': '+689', 'PG': '+675', 'PH': '+63', 'PK': '+92', 'PL': '+48', 'PM': '+508',
                'PN': '+64', 'PR': '+1', 'PS': '+970', 'PT': '+351', 'PW': '+680', 'PY': '+595', 'QA': '+974', 'RE': '+262',
                'RO': '+40', 'RS': '+381', 'RU': '+7', 'RW': '+250', 'SA': '+966', 'SB': '+677', 'SC': '+248', 'SD': '+249',
                'SE': '+46', 'SG': '+65', 'SH': '+290', 'SI': '+386', 'SJ': '+47', 'SK': '+421', 'SL': '+232', 'SM': '+378',
                'SN': '+221', 'SO': '+252', 'SR': '+597', 'SS': '+211', 'ST': '+239', 'SV': '+503', 'SX': '+1', 'SY': '+963',
                'SZ': '+268', 'TC': '+1', 'TD': '+235', 'TF': '+262', 'TG': '+228', 'TH': '+66', 'TJ': '+992', 'TK': '+690',
                'TL': '+670', 'TM': '+993', 'TN': '+216', 'TO': '+676', 'TR': '+90', 'TT': '+1', 'TV': '+688', 'TW': '+886',
                'TZ': '+255', 'UA': '+380', 'UG': '+256', 'UM': '+1', 'US': '+1', 'UY': '+598', 'UZ': '+998', 'VA': '+39',
                'VC': '+1', 'VE': '+58', 'VG': '+1', 'VI': '+1', 'VN': '+84', 'VU': '+678', 'WF': '+681', 'WS': '+685',
                'YE': '+967', 'YT': '+262', 'ZA': '+27', 'ZM': '+260', 'ZW': '+263'
            },
        }
        // if(this.country !== undefined) {
        //     data.autocompleteOptions.componentRestrictions.country = [this.country]
        // }
        return data
    },
    watch: {
        'address': {
            handler: function (val) {
                if (val && !val.company_name) {
                    this.$set(val, 'company_name', '');
                }
            },
            immediate: true,
            deep: true
        },
        'alternative.name': function (val) {
            this.emptyName = (val == '')
            this.verifyAddress()
        },
        'alternative.surname': function (val) {
            this.emptySurname = (val == '')
            this.verifyAddress()
        },
        'alternative.company_name': function (val) {
            this.emptyCompanyName = (val == '')
            this.verifyAddress()
        },
        'alternative.address': function (val) {
            this.emptyAddress = (val == '')
            const cleanedAddress = val.replace(/\s+/g, ' ')
            if (cleanedAddress !== val) {
                this.alternative.address = cleanedAddress
                return;
            }
            this.emptyAddress = (cleanedAddress == '')
            this.addressTooShort = (cleanedAddress.length > 0 && cleanedAddress.length < 6)
            this.verifyAddress()
        },
        'alternative.zip_code': function (val) {
            this.emptyZipCode = (val == '')
            this.verifyAddress()
        },
        'alternative.district': function (val) {
            this.emptyDistrict = (val == '')
            this.verifyAddress()
        },
        'alternative.city': function (val) {
            this.emptyCity = (val == '')
            this.verifyAddress()
        },
        'alternative.country': function (val) {
            this.emptyCountry = (val == '')
            // Aggiorna il prefisso telefonico quando cambia il paese
            if (val && this.countryPrefixes[val]) {
                this.telephonePrefix = this.countryPrefixes[val]
            }
            this.verifyAddress()
        },
        'telephonePrefix': function (val) {
            // Combina prefisso e numero nel campo telephone dell'oggetto alternative (senza spazi)
            this.updateCombinedTelephone()
        },
        'telephoneNumber': function (val) {
            // Combina prefisso e numero nel campo telephone dell'oggetto alternative (senza spazi)
            this.updateCombinedTelephone()
        },
    },
    mounted() {
        // Assicurati che company_name sia sempre presente nell'oggetto alternative
        if (!this.alternative.company_name) {
            this.$set(this.alternative, 'company_name', '');
        }

        // Inizializza i campi prefisso e numero dal telefono esistente
        this.initializeTelephoneFields()
        this.verifyAddress()

        // Inizializza il prefisso se c'è già un paese selezionato ma non c'è prefisso
        if (this.alternative.country && this.countryPrefixes[this.alternative.country] && !this.telephonePrefix) {
            this.telephonePrefix = this.countryPrefixes[this.alternative.country]
        }
    },
    methods: {
        verifyAddress() {
            const list = ['name', 'surname', 'address', 'country', 'city', 'district', 'zip_code', 'telephone']
            let check = true
            let checkLatin = true

            let nameCheck = true
            let surnameCheck = true
            let companyNameCheck = true
            let addressCheck = true
            let zipCodeCheck = true
            let cityCheck = true
            let districtCheck = true
            let telephoneCheck = true

            list.forEach(element => {
                if (process.env.NODE_ENV === "development") {
                    console.log('@verifyAddress', element, this.alternative[element]);
                }

                if (this.alternative[element] == '' || this.alternative[element] == null || this.alternative[element] == undefined || this.alternative[element] == 'undefined') {
                    switch (element) {
                        case 'name':
                            this.emptyName = true
                            break;
                        case 'surname':
                            this.emptySurname = true
                            break;
                        case 'address':
                            this.emptyAddress = true
                            break;
                        case 'country':
                            this.emptyCountry = true
                            break;
                        case 'city':
                            this.emptyCity = true
                            break;
                        case 'district':
                            this.emptyDistrict = true
                            break;
                        case 'zip_code':
                            this.emptyZipCode = true
                            break;
                        case 'telephone':
                            this.emptyTelephone = true
                            break;
                    }
                    check = false
                } else {
                    var regex = /([^A-Za-z0-9,\s+])/g;
                    switch (element) {
                        case 'name':
                        case 'surname':
                        case 'city':
                        case 'district':
                            regex = /([^A-Za-z\s])/g;
                            break;
                        case 'zip_code':
                            regex = /([^A-Za-z0-9\s])/g;
                            break;
                        case 'telephone':
                            // Valida sia il prefisso che il numero
                            const prefixValid = !this.telephonePrefix || /^[+][0-9]+$/.test(this.telephonePrefix)
                            const numberValid = !this.telephoneNumber || /^[0-9\s]+$/.test(this.telephoneNumber)
                            const numberNotEmpty = this.telephoneNumber && this.telephoneNumber.trim() !== ''
                            const numberMinLength = this.telephoneNumber && this.telephoneNumber.replace(/\s/g, '').length >= 6

                            if (!prefixValid || !numberValid || !numberNotEmpty || !numberMinLength) {
                                telephoneCheck = false
                                check = false
                                return
                            }
                            break;
                    }

                    if (this.alternative[element].match(regex)) {
                        switch (element) {
                            case 'name':
                                nameCheck = false
                                break;
                            case 'surname':
                                surnameCheck = false
                                break;
                            case 'address':
                                addressCheck = false
                                break;
                            case 'zip_code':
                                zipCodeCheck = false
                                break;
                            case 'city':
                                cityCheck = false
                                break;
                            case 'district':
                                districtCheck = false
                                break;
                        }
                        check = false
                        return
                    }
                }
            })

            // Validazione separata per company_name (opzionale)
            if (this.alternative.company_name && this.alternative.company_name.trim() !== '') {
                var regex = /([^A-Za-z0-9\s.,'-])/g;
                if (this.alternative.company_name.match(regex)) {
                    companyNameCheck = false
                }
            }

            // this.charsetsLatin = checkLatin
            this.nameCheck = nameCheck
            this.surnameCheck = surnameCheck
            this.companyNameCheck = companyNameCheck
            this.addressCheck = addressCheck
            this.zipCodeCheck = zipCodeCheck
            this.cityCheck = cityCheck
            this.districtCheck = districtCheck
            this.telephoneCheck = telephoneCheck
            this.checked = check && !this.addressTooShort && companyNameCheck
        },
        initializeTelephoneFields() {
            const currentTelephone = this.alternative.telephone || ''
            if (currentTelephone) {
                // Se il numero inizia già con +, cerca un prefisso conosciuto
                if (currentTelephone.startsWith('+')) {
                    for (const [country, prefix] of Object.entries(this.countryPrefixes)) {
                        if (currentTelephone.startsWith(prefix + ' ')) {
                            this.telephonePrefix = prefix
                            this.telephoneNumber = currentTelephone.substring(prefix.length + 1).trim()
                            return
                        } else if (currentTelephone.startsWith(prefix)) {
                            this.telephonePrefix = prefix
                            this.telephoneNumber = currentTelephone.substring(prefix.length).trim()
                            return
                        }
                    }
                    // Se inizia con + ma non corrisponde a nessun prefisso conosciuto, mette tutto nel numero
                    this.telephoneNumber = currentTelephone
                } else {
                    // Se non inizia con +, prova ad aggiungere + e vedere se corrisponde a un prefisso
                    const telephoneWithPlus = '+' + currentTelephone
                    let foundValidPrefix = false

                    for (const [country, prefix] of Object.entries(this.countryPrefixes)) {
                        if (telephoneWithPlus.startsWith(prefix)) {
                            this.telephonePrefix = prefix
                            this.telephoneNumber = telephoneWithPlus.substring(prefix.length).trim()
                            foundValidPrefix = true
                            break
                        }
                    }

                    // Se non trova un prefisso valido, usa il prefisso della nazione selezionata o mette tutto nel numero
                    if (!foundValidPrefix) {
                        if (this.alternative.country && this.countryPrefixes[this.alternative.country]) {
                            this.telephonePrefix = this.countryPrefixes[this.alternative.country]
                            this.telephoneNumber = currentTelephone
                        } else {
                            this.telephoneNumber = currentTelephone
                        }
                    }
                }
            }
        },
        getTelephoneNumberPlaceholder() {
            if (this.telephonePrefix) {
                // Esempi di formato per alcuni paesi comuni (solo la parte numerica)
                const examples = {
                    '+39': '123 456 7890', // Italia
                    '+33': '1 23 45 67 89', // Francia
                    '+49': '123 4567890', // Germania
                    '+44': '20 1234 5678', // Regno Unito
                    '+1': '123 456 7890', // USA/Canada
                    '+34': '123 456 789', // Spagna
                }
                return examples[this.telephonePrefix] || '123456789'
            }
            return this.strings['shipping_telephone'] || 'Numero di telefono'
        },
        updateCombinedTelephone() {
            // Rimuovi spazi dal numero
            const cleanNumber = this.telephoneNumber ? this.telephoneNumber.replace(/\s/g, '') : ''

            // Combina prefisso e numero (tutto attaccato, senza spazi)
            if (this.telephonePrefix && cleanNumber) {
                this.alternative.telephone = this.telephonePrefix + cleanNumber
            } else if (this.telephonePrefix) {
                this.alternative.telephone = this.telephonePrefix
            } else if (cleanNumber) {
                this.alternative.telephone = cleanNumber
            } else {
                this.alternative.telephone = ''
            }

            this.emptyTelephone = (this.alternative.telephone == '')
            this.verifyAddress()
        }
    }
}
</script>
